import { useState } from 'react';
import './ImageGallery.css';

interface ImageGalleryProps {
  images: {
    src: string;
    alt: string;
    title?: string;
  }[];
  columns?: number;
}

const ImageGallery = ({ images, columns = 3 }: ImageGalleryProps) => {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  const openLightbox = (index: number) => {
    setSelectedImage(index);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const nextImage = () => {
    if (selectedImage !== null) {
      setSelectedImage((selectedImage + 1) % images.length);
    }
  };

  const prevImage = () => {
    if (selectedImage !== null) {
      setSelectedImage(selectedImage === 0 ? images.length - 1 : selectedImage - 1);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowRight') nextImage();
    if (e.key === 'ArrowLeft') prevImage();
  };

  return (
    <>
      <div 
        className={`image-gallery columns-${columns}`}
        style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
      >
        {images.map((image, index) => (
          <div 
            key={index}
            className="gallery-item"
            onClick={() => openLightbox(index)}
          >
            <img 
              src={image.src} 
              alt={image.alt}
              loading="lazy"
            />
            <div className="gallery-overlay">
              <span className="enlarge-icon">🔍</span>
              <span className="enlarge-text">Click to Enlarge</span>
            </div>
          </div>
        ))}
      </div>

      {selectedImage !== null && (
        <div 
          className="lightbox-overlay"
          onClick={closeLightbox}
          onKeyDown={handleKeyDown}
          tabIndex={0}
        >
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button 
              className="lightbox-close"
              onClick={closeLightbox}
              aria-label="Close lightbox"
            >
              ×
            </button>
            
            <button 
              className="lightbox-nav lightbox-prev"
              onClick={prevImage}
              aria-label="Previous image"
            >
              ‹
            </button>
            
            <img 
              src={images[selectedImage].src}
              alt={images[selectedImage].alt}
              className="lightbox-image"
            />
            
            <button 
              className="lightbox-nav lightbox-next"
              onClick={nextImage}
              aria-label="Next image"
            >
              ›
            </button>
            
            {images[selectedImage].title && (
              <div className="lightbox-caption">
                {images[selectedImage].title}
              </div>
            )}
            
            <div className="lightbox-counter">
              {selectedImage + 1} / {images.length}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ImageGallery;